import { zollBaseURL } from '../../../services/api.service'
import { ZollAPIService } from '../../../services/zollApi.service'
import { INotificationCenterResponse, INotificationIdsResponse } from '../store/notificationCenter.types'

const fetchQaFlagsURL = () => `${zollBaseURL}/api/notifications`
const fetchNotificationIdsURL = () => `${zollBaseURL}/api/notifications/ids`

export class NotificationCenterService extends ZollAPIService {
  async fetchNotifications(): Promise<INotificationCenterResponse> {
    return this.get(fetchQaFlagsURL())
  }

  async fetchNotificationIds(): Promise<INotificationIdsResponse> {
    return this.get(fetchNotificationIdsURL())
  }
}
